var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17676 9.34611C8.85988 8.79897 10.9571 6.49957 12.2248 4.16211C13.8872 5.88059 16.6636 7.52563 19.2431 7.52563C20.8796 7.52563 22.4158 7.09526 23.7448 6.34213",
    stroke: "#B7CCFF",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4727 19.1379C27.0826 18.9659 28.3527 16.9686 28.3527 14.5301C28.3527 12.0912 27.0826 10.0939 25.4727 9.92188V19.1379Z",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3922 26.625C16.1874 26.625 16.8321 27.2698 16.8321 28.065C16.8321 28.8602 16.1874 29.505 15.3922 29.505C14.5969 29.505 13.9521 28.8602 13.9521 28.065C13.9521 27.2698 14.5969 26.625 15.3922 26.625Z",
    fill: "#A020FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6231 27.551C19.4501 27.2783 21.3011 26.6392 22.5454 25.3926C24.0908 23.8447 25.295 21.2202 25.295 18.8729V10.8863C25.295 8.53895 24.0908 6.15899 22.5454 4.61138C21.0002 3.06329 18.6237 1.85742 16.2801 1.85742H15.1106C12.7668 1.85742 10.3907 3.06329 8.84548 4.61138C7.30006 6.15899 6.17676 7.57405 6.17676 9.92142",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39029 19.0236C4.17797 18.8537 2.43262 16.8812 2.43262 14.4729C2.43262 12.0643 4.17797 10.0917 6.39029 9.92188V19.0236Z",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4727 19.0236C27.685 18.8537 29.4303 16.8812 29.4303 14.4729C29.4303 12.0643 27.685 10.0917 25.4727 9.92188V19.0236Z",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6818 25.6348C16.7486 25.6348 17.6135 26.5011 17.6135 27.5696C17.6135 28.6381 16.7486 29.5044 15.6818 29.5044C14.615 29.5044 13.75 28.6381 13.75 27.5696C13.75 26.5011 14.615 25.6348 15.6818 25.6348Z",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9248 10.138C8.75639 9.55996 11.137 7.73913 12.4748 5.26953C14.2292 7.08516 16.688 8.21464 19.4103 8.21464C21.1373 8.21464 22.7585 7.75994 24.161 6.96423",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.25fbef1e008f0b94c02758415753688e.svg";
export { ForwardRef as ReactComponent };